import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type ImportedDocumentsFetchFailedAction = {
	type: 'IMPORTED_DOCUMENTS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): ImportedDocumentsFetchFailedAction => ({
	type: 'IMPORTED_DOCUMENTS_FETCH_FAILED',
	payload,
});
